
import { Button } from '@/components/ui/button';

interface TaskEmptyProps {
  onAddTask: () => void;
}

const TaskEmpty: React.FC<TaskEmptyProps> = ({ onAddTask }) => {
  return (
    <div className="text-center py-8">
      <p className="text-muted-foreground mb-4">No tasks created yet</p>
      <Button onClick={onAddTask}>Add Task</Button>
    </div>
  );
};

export default TaskEmpty;
